import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification, Select} from 'antd';

import {addCategory, getCategoryTree} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {bindActionCreators} from "redux";
import {getTaxGroups} from "../Tax/actions";
import {formItemLayout} from "../utils/style";
import SelectCategoryTree from "./SelectCategoryTree";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddCategoryForm extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    addCategory: PropTypes.func.isRequired,
    salonId: PropTypes.string.isRequired,
    categoryTree: PropTypes.object.isRequired,
    getCategoryTree: PropTypes.func.isRequired,
    taxGroups: PropTypes.array.isRequired,
    getTaxGroups: PropTypes.func.isRequired
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.salonId !== prevProps.salonId) {
      this._load();
    }
  }

  _load = () => {
    const {salonId} = this.props;
    if (salonId) {
      this.props.getCategoryTree({salonId});
      this.props.getTaxGroups({salonId});
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {salonId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addCategory({...values, salonId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {categoryTree, form: {getFieldDecorator, getFieldsError}, loading, taxGroups} = this.props;
    return (
      <Card title="Add Category">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Parent"
          >
            {getFieldDecorator('parentId', {
              initialValue: null
            })(
              <SelectCategoryTree tree={categoryTree} noneText="NONE" />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Tax Group"
          >
            {getFieldDecorator('taxGroupId', {
              initialValue: null
            })(
              <Select>
                <Option key="category-taxGroupId-null" value={null}>NONE</Option>
                {taxGroups.map(taxGroup =>
                  <Option key={taxGroup.taxGroupId} value={taxGroup.taxGroupId}>{taxGroup.name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Category
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const AddCategoryPage = Form.create()(AddCategoryForm);

const mapStateToProps = state => ({
  loading: state.category.categoriesLoading || state.category.addingCategory,
  salonId: state.salon.selectedSalonId,
  categoryTree: state.category.categoryTree,
  taxGroups: state.tax.taxGroups
});

const mapDispatchToProps = dispatch => bindActionCreators({
  addCategory,
  getCategoryTree,
  getTaxGroups,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddCategoryPage);



// WEBPACK FOOTER //
// ./src/Category/AddCategoryPage.js